
    const initCoachMark = () => {
        const coachmark = document.querySelector('#coachmark-action');
        coachmark.addEventListener('primary', () => console.log('primary call to action'));
        coachmark.addEventListener('secondary', () => console.log('secondary call to action'));
    };
    customElements.whenDefined('sp-coachmark').then(() => {
                initCoachMark();
    });
